import React, { memo } from 'react';
import LazyImage from '../../../../../components/CustomLibraries/LazyImage';
import '../../scss/dt_profile.scss';
import '../../scss/dt_profileRight.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../../../../components/ContentSlider/css/contentSlider.scss';
import { openNewTab } from '../../../../../common/common';

const AnalyticMetrix = ({ data, isOnMasonry = false, height = 'auto' }) => {
  return (
    <>
      <div
        className="w-100 dt_Counts bg-white shadow rounded-3 position-relative mb-5 d-flex flex-column p-3 p-md-4"
        style={{ height: isOnMasonry ? height : 'auto' }}
      >
        <div className="doctubeLogo_right mb-4">
          <div className="w-100 h-100 text-center d-flex justify-content-center align-items-center">
            <LazyImage
              src="https://ik.imagekit.io/doctube/logo.svg"
              className={`mw-100 mh-100 w-auto h-auto`}
            />
          </div>
        </div>
        <h5 className={`fs-4 fw-normal text-black mb-4 ${isOnMasonry ? 'mt-4' : ''}`}>
          DocTube™ is a health eduction platform with a vision to strengthen trust between doctors
          and patients to better healthcare outcomes.
        </h5>
        <div
          className={`counts d-flex justify-content-center mb-4 gap-5 ${
            isOnMasonry ? 'mt-auto' : ''
          }`}
        >
          {data?.total_channel && (
            <div className="singleCount text-center">
              <h4 className="countNum mb-3 pb-3 fs-2 fw-semibold text-black position-relative">
                {data?.total_channel}
              </h4>
              <h6 className="countName fs-4 fw-medium">Channels</h6>
            </div>
          )}
          {data?.total_videos && (
            <div className="singleCount text-center">
              <h4 className="countNum mb-3 pb-3 fs-2 fw-semibold text-black position-relative">
                {data?.total_videos}
              </h4>
              <h6 className="countName fs-4 fw-medium">Videos</h6>
            </div>
          )}
          {data?.total_users && (
            <div className="singleCount text-center">
              <h4 className="countNum mb-3 pb-3 fs-2 fw-semibold text-black position-relative">
                {data?.total_users}
              </h4>
              <h6 className="countName fs-4 fw-medium">User</h6>
            </div>
          )}
        </div>
        <a
          href="javascript:void(0)"
          className="w-100 btn btn-warning fs-4 fw-medium text-capitalize rounded-3 exploreBtn mt-auto py-3 px-4 gtm_cl_doctube_dashboard_analyticMetrix_exploreDoctube"
          onClick={() =>
            openNewTab(process.env.REACT_APP_DOCTUBE_BASE_URL_LIVE, () => {
              window.location.href = process.env.REACT_APP_DOCTUBE_BASE_URL_LIVE;
            })
          }
        >
          Explore DocTube™
        </a>
      </div>
    </>
  );
};

export default memo(AnalyticMetrix);
